module.exports = __webpack_public_path__ + "img/192.84781f10.jpg";